module.exports = __webpack_public_path__ + "img/avatar-motor.png";